import { Component, OnInit, Input } from '@angular/core';
import { PreparationBasic } from 'src/app/models/catalogs-model/preparation.model';
import { Subscription } from 'rxjs/internal/Subscription';
import { PreparationsService } from 'src/app/services/catalogs-services/preparations-services/preparations.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { ConfirmationDialogComponent } from '../../shared-components/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-catalogs-preparation-resume-card',
  templateUrl: './catalogs-preparation-resume-card.component.html',
  styleUrls: ['./catalogs-preparation-resume-card.component.scss']
})
export class CatalogsPreparationResumeCardComponent implements OnInit {

  @Input() preparation: PreparationBasic;
  @Input() viewDisposition;
  deletePreparationSubscription: Subscription;
  updatePreparationStatusSubscription: Subscription;

  constructor(private preparationsService: PreparationsService,
              private snackbarService: SnackBarService,
              private router: Router,
              private dialog: MatDialog) { }

  ngOnInit() { }

  public gotoDetails(e) {
    if ((e.target.className !== 'mat-icon notranslate material-icons mat-icon-no-color') && (e.target.className !== 'mat-icon-button') && (e.target.tagName !== 'SPAN')) {
      this.router.navigate(['/catalog/preparation', this.preparation.InternalId]);
    }
  }

  public toggleStatus() {
    this.updatePreparationStatusSubscription = this.preparationsService.updatePreparationStatus(this.preparation.InternalId, !this.preparation.Active).subscribe(
      (res) => {
        this.preparationsService.refreshPreparations();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public deletePreparation() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'important',
        messages: ['catalogs-page.delete preparation', 'delete anyway']
      }
    });

    dialogRef.afterClosed().subscribe(action => {
      if (action) {
        this.deletePreparationSubscription = this.preparationsService.deletePreparation([this.preparation.InternalId]).subscribe(
          (res) => {
            this.preparationsService.refreshPreparations();
          },
          (error) => {
            this.snackbarService.open(error['error']['message'], 'error');
          }
        );
      }
    });
  }

}
